;(function () {
  const components = {
    messageMarquee: SAXX.Init.Component((node) => {
      const marqueeContainers = []

      const getObjectWidth = (obj) => {
        if (obj.offsetWidth) return obj.offsetWidth
        if (obj.clip) return obj.clip.width
        return 0
      }
      const createMarqueeContainer = (node) => {
        const container = node
        const itemWidthPx =
          getObjectWidth(
            container.querySelector('.message-marquee--container'),
          ) + 5
        const fullWidthPx = getObjectWidth(container)
        const itemWidthRem = itemWidthPx / 16 // Convert px to rem
        const fullWidthRem = fullWidthPx / 16

        const textContent = container.querySelector(
          '.message-marquee--container',
        ).innerHTML
        container.innerHTML = ''
        const heightPx = Number(container.style.height)
        const heightRem = heightPx / 16 // Convert height to rem
        container.items = []
        const maxItems = Math.ceil(fullWidthRem / itemWidthRem) + 1

        for (let i = 0; i < maxItems; i++) {
          container.items[i] = document.createElement('div')
          container.items[i].classList.add('message-marquee--container')
          container.items[i].innerHTML = textContent
          container.items[i].style.position = 'absolute'
          container.items[i].style.left = itemWidthRem * i + 'rem' // Use rem
          container.items[i].style.width = itemWidthRem + 'rem' // Use rem
          container.items[i].style.height = heightRem + 'rem' // Use rem
          container.appendChild(container.items[i])
        }

        marqueeContainers.push(container)
      }

      const rotateMarquee = (containers) => {
        if (!containers) return
        for (let j = containers.length - 1; j > -1; j--) {
          const maxItems = containers[j].items.length

          for (let i = 0; i < maxItems; i++) {
            const itemStyle = containers[j].items[i].style
            itemStyle.left = parseFloat(itemStyle.left) - 0.0625 + 'rem' // Move by 1px equivalent in rem
          }

          const firstItemStyle = containers[j].items[0].style

          if (
            parseFloat(firstItemStyle.left) + parseFloat(firstItemStyle.width) <
            0
          ) {
            const shiftedItem = containers[j].items.shift()
            shiftedItem.style.left =
              parseFloat(shiftedItem.style.left) +
              parseFloat(shiftedItem.style.width) * maxItems +
              'rem'
            containers[j].items.push(shiftedItem)
          }
        }
        containers[0].animationID = requestAnimationFrame(() =>
          rotateMarquee(containers),
        )
      }

      createMarqueeContainer(node)
      rotateMarquee(marqueeContainers)
    }),
  }
  Object.assign(SAXX.Init.Components, components)
})()
